import { Component, OnInit} from '@angular/core';
import { ReusableClasses } from '../reusableclassesAndFunctions/reusable-classes';
import { EncryptionService } from '../../encryption/encryption.service';
import * as jwt_decode from 'jwt-decode';
import { FormGroup, FormBuilder } from '@angular/forms';
import { CoreService } from 'src/app/applicationModules/core/services/coreService/core.service';
import { ToastrService } from 'ngx-toastr';
import { MatDialogRef } from '@angular/material/dialog';
import { StatusConstant } from '../status/status-constant';

@Component({
  selector: 'app-addcustomInfotype',
  templateUrl: './addcustomInfotype.component.html',
  styleUrls: ['./addcustomInfotype.component.scss'] 
})

export class AddCustomInfoTypeComponent implements OnInit {
  organizationId: string;
  databaseId: string;
  currentUser: any;
  responseHolder: any;    
  formDialog: FormGroup; 
  spinner:boolean=false;
  OfficeIDList: any=[];
  myOfficeID: any;
  selectedCustomInfoTypeID:number=0;
  ShowNoRecordFoundStatus:boolean=false;
  customInfoNameList:any=[]=[];
  customInfoNameFilterList:any=[]=[];

  constructor(public dialogRef: MatDialogRef<AddCustomInfoTypeComponent>,  
    private formBuilder: FormBuilder,private encryptionAlgo: EncryptionService,
    private reusableClass: ReusableClasses, private coreService: CoreService,
    private toastr: ToastrService,private statusConst: StatusConstant) {   
    const encryptedtoken = sessionStorage.getItem('userToken');
    this.databaseId = sessionStorage.getItem('databaseId');
    this.organizationId = sessionStorage.getItem('organizationID');
    if(encryptedtoken!=null){
      const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey,encryptedtoken);   
      this.currentUser = jwt_decode(token); 
      var offices=JSON.parse(sessionStorage.getItem('officeList'));
      offices.forEach(oe => {
      this.OfficeIDList.push(oe.officeID);
      if(oe.isMyoffice==true)
        this.myOfficeID=oe.officeID;
      });
    } 
  }  
  
  ngOnInit(): void {  
    let groupaddtouchtype = {};
    this.formDialog = new FormGroup(groupaddtouchtype);
    this.formDialog.addControl('touchTypeName', this.formBuilder.control(''));
    this.unMappedtCustomInfoTypes(); 
   }     
       
   unMappedtCustomInfoTypes(){
    let ReqModel = {          
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      userId: this.currentUser.UID,
      officeID:this.myOfficeID
    }   
    this.coreService.unMappedtCustomInfoTypes(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;       
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.customInfoNameList= this.responseHolder.data;
          this.customInfoNameFilterList= this.responseHolder.data;
          if(this.customInfoNameList.length>0){
            this.ShowNoRecordFoundStatus=false;
          }else{
            this.ShowNoRecordFoundStatus=true;
          }
        }
        else{
                    
        }
      }else{
        
      }
    });
   }


  AddTouchTypeName(data) {
     let ReqModel = {
      touchTypeName: data.touchTypeName.trim(),      
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      userId: this.currentUser.UID,
      officeID:this.myOfficeID
    }
    this.spinner=true;
    this.formDialog.markAsPristine();
    this.coreService.addCustomNoteType(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.spinner=false;
        if (this.responseHolder.data == true) {
          this.formDialog.reset();
          this.dialogRef.close('Added');
          this.toastr.success('Custom info type name added successfully.', '', {
            timeOut: 2000,
          });     
        }else{
          this.spinner=false;
          this.toastr.warning('Already exist.', '', {
            timeOut: 2000,
          });         
        }
      }else{
        this.spinner=false;
      }
    });
  }

   closeAddTouchType() {
    this.formDialog.reset();    
    this.dialogRef.close();
  }

  SelectStatus(data){
    this.selectedCustomInfoTypeID = data.customInfoTypeID;
    this.formDialog.controls['touchTypeName'].setValue(data.customInfoName);
    this.formDialog.markAsDirty();   
  }

  onSearchChange(searchValue: string): void {   
    if(searchValue==""){
      this.selectedCustomInfoTypeID=0;
      this.unMappedtCustomInfoTypes();     
    }else{
      this.selectedCustomInfoTypeID=0;
      this.customInfoNameList= this.customInfoNameFilterList.filter(x=>x.customInfoName.toLowerCase()==searchValue.toLowerCase());
      if(this.customInfoNameList.length>0){
        this.ShowNoRecordFoundStatus=false;
      }else{
        this.ShowNoRecordFoundStatus=true;
      }      
    }
  }

}
